import React, { PropTypes } from 'react';

function Books() {
    return(
        <div className = "books">
            <h1 id="title">BOOKS</h1>
    <nav id="tree-list">
        <ul className="container">
            <li>
                <h3 data-aos="flip-left">Engg. Physics</h3>
                <ul className="tree-down"  data-aos="fade-up">
                    <li>Arthur Biser(for Quantum &amp; Statistical Mechanics)<a href="https://drive.google.com/open?id=1Ghfoa3cjpfUpEOr1YpTifEz1iISRd89R"><img src="https://media.istockphoto.com/vectors/download-icon-isolated-vector-vector-id844294300?b=1&k=6&m=844294300&s=170x170&h=PJYj3qPn7fw7kD3RJ69J2KCISM949mLClsi78FT_djA=" alt="Download"/></a></li>
                    <li>Avadhanulu(For STR &amp; Classical Mechanics)<a href="https://drive.google.com/open?id=1F64YwcyNmZ273J3rONr8QfYCQxcX6S8X"><img src="https://media.istockphoto.com/vectors/download-icon-isolated-vector-vector-id844294300?b=1&k=6&m=844294300&s=170x170&h=PJYj3qPn7fw7kD3RJ69J2KCISM949mLClsi78FT_djA=" alt="Download"/>
                    </a></li>
                    <li>
                    R.K Puri and Babbar(for Solid State Physics)<a href="http://download.library1.org/main/2219000/4ecbef87fa015cedf81ae87f931a5031/R.%20K.%20Puri%2C%20V.K.%20Babbar%20-%20Solid%20State%20Physics-S%20Chand%20%26%20Co%20Ltd%20%282010%29.pdf"><img src="https://media.istockphoto.com/vectors/download-icon-isolated-vector-vector-id844294300?b=1&k=6&m=844294300&s=170x170&h=PJYj3qPn7fw7kD3RJ69J2KCISM949mLClsi78FT_djA=" alt="Download"/></a></li>
                </ul>
            </li>
            <li>
                <h3 data-aos="flip-left">Engg. Mathematics</h3>
                <ul className="tree-down"  data-aos="fade-up">
                    <li>
                    B.S Grewal<a href="https://drive.google.com/uc?export=download&confirm=cix0&id=1tutv70dQJ8oFa2yZs_oywZiAyWNDzMOi"><img src="https://media.istockphoto.com/vectors/download-icon-isolated-vector-vector-id844294300?b=1&k=6&m=844294300&s=170x170&h=PJYj3qPn7fw7kD3RJ69J2KCISM949mLClsi78FT_djA=" alt="Download"/></a></li>
                </ul>
            </li>
            <li>
                <h3 data-aos="flip-left">Engg. Chemistry</h3>
                <ul className="tree-down"  data-aos="fade-up">
                    <li>Jain and Jain<a href="https://drive.google.com/open?id=1Ozhp8hQPvl1w3VNJPaL_4hoEElz2Na2V"><img src="https://media.istockphoto.com/vectors/download-icon-isolated-vector-vector-id844294300?b=1&k=6&m=844294300&s=170x170&h=PJYj3qPn7fw7kD3RJ69J2KCISM949mLClsi78FT_djA=" alt="Download"/></a></li>
                    <li>Polymer Science and Technology<a href="https://drive.google.com/open?id=1TFnICyaRetEpinfu_bjHc9dMXLPOuk65"><img src="https://media.istockphoto.com/vectors/download-icon-isolated-vector-vector-id844294300?b=1&k=6&m=844294300&s=170x170&h=PJYj3qPn7fw7kD3RJ69J2KCISM949mLClsi78FT_djA=" alt="Download"/></a></li>
                    <li></li>
                </ul>
            </li>
            <li>
                <h3 data-aos="flip-left">Basic Electronics</h3>
                <ul className="tree-down"  data-aos="fade-up">
                    <li>Bolyestad <a href="https://drive.google.com/open?id=1F64YwcyNmZ273J3rONr8QfYCQxcX6S8X"><img src="https://media.istockphoto.com/vectors/download-icon-isolated-vector-vector-id844294300?b=1&k=6&m=844294300&s=170x170&h=PJYj3qPn7fw7kD3RJ69J2KCISM949mLClsi78FT_djA=" alt="Download"/></a></li>
                    <li>V.K Mehta <a href="http://download.library1.org/main/1016000/e3ca13718e12cc7a337184154dc829a2/V.%20K.%20Mehta%2C%20Rohit%20Mehta%20-%20Principles%20of%20Electronics-S.%20Chand%20%26%20Co%20Ltd%20%282008%29.pdf"><img src="https://media.istockphoto.com/vectors/download-icon-isolated-vector-vector-id844294300?b=1&k=6&m=844294300&s=170x170&h=PJYj3qPn7fw7kD3RJ69J2KCISM949mLClsi78FT_djA=" alt="Download"/></a></li>
                </ul>
            </li>
            <li>
                <h3 data-aos="flip-left"> Basic Electrical</h3>
                <ul className="tree-down"  data-aos="fade-up">
                    <li>Tata McGraw Hill <a href="https://drive.google.com/open?id=1fr1RxSsiuf6np7JAa7J6YtERPLsczDz0"><img src="https://media.istockphoto.com/vectors/download-icon-isolated-vector-vector-id844294300?b=1&k=6&m=844294300&s=170x170&h=PJYj3qPn7fw7kD3RJ69J2KCISM949mLClsi78FT_djA=" alt="Download"/></a></li>
                    <li>B.L Thareja(for Electrical Machines) <a href="https://drive.google.com/open?id=1vgT35nPUFUtTS82yLxFV64Azn6Dh3IZ4"><img src="https://media.istockphoto.com/vectors/download-icon-isolated-vector-vector-id844294300?b=1&k=6&m=844294300&s=170x170&h=PJYj3qPn7fw7kD3RJ69J2KCISM949mLClsi78FT_djA=" alt="Download"/></a></li>
                </ul>
            </li>
            <li>
                <h3 data-aos="flip-left">Economics</h3>
                <ul className="tree-down"  data-aos="fade-up"> 
                    <li>Notes Available, Check out the Notes section</li>
                </ul>
            </li>
            <li>
                <h3 data-aos="flip-left">Communication Skills</h3>
                <ul className="tree-down"  data-aos="fade-up">
                    <li>Notes Available, Check out the Notes section</li>
                </ul>
            </li>
            <li>
                <h3 data-aos="flip-left">Environmental Studies</h3>
                <ul className="tree-down"  data-aos="fade-up">
                    <li>Notes available, Check out the Notes section</li>
                </ul>
            </li>
            <li>
                <h3 data-aos="flip-left">Digital Electronics</h3>
                <ul className="tree-down"  data-aos="fade-up">
                    <li>Notes Available, Check out the Notes section</li>
                </ul>
            </li>
            <li>
                <h3 data-aos="flip-left">C Programming</h3>
                <ul className="tree-down"  data-aos="fade-up">
                    <li>Let us C by Yashwant Kanetkar<a href="http://download.library1.org/main/63000/43df4fe9e75f7efc467094e4bcbb5880/Yashavant%20Kanetkar%20-%20Let%20Us%20C-BPB%20Publications%20%282004%29.pdf"><img src="https://media.istockphoto.com/vectors/download-icon-isolated-vector-vector-id844294300?b=1&k=6&m=844294300&s=170x170&h=PJYj3qPn7fw7kD3RJ69J2KCISM949mLClsi78FT_djA=" alt="Download"/></a></li>
                </ul>
            </li>
            <li>
                <h3 data-aos="flip-left">Python</h3>
                <ul className="tree-down"  data-aos="fade-up">
                    <li>Notes Available, Check out the Notes section</li>
                </ul>
            </li>
        </ul>
    </nav>


        </div>
    )
}


export default Books;